import type { ReactNode } from "react";

import { Checkbox, CheckboxState, Text } from "@alpacahq/ui/old";

export interface YesNoCheckboxProps {
  isChecked: boolean;
  setValue: (value: boolean) => void;
  label: string;
  underLabel?: ReactNode;
}

export const YesNoCheckbox = ({
  isChecked,
  setValue,
  label,
  underLabel,
}: YesNoCheckboxProps) => (
  <div className="flex flex-col gap-2">
    <label className="block font-medium text-gray-900 text-md leading-6 dark:text-gray-100">
      {label}
    </label>
    {underLabel}
    <div className="flex items-center justify-start gap-3">
      <div
        className="flex items-center justify-start gap-1.5"
        onClick={() => setValue(true)}
      >
        <Checkbox
          state={isChecked ? CheckboxState.Checked : CheckboxState.Unchecked}
        />
        <Text className="cursor-pointer">Yes</Text>
      </div>
      <div
        className="flex items-center justify-start gap-1.5"
        onClick={() => setValue(false)}
      >
        <Checkbox
          state={!isChecked ? CheckboxState.Checked : CheckboxState.Unchecked}
        />
        <Text className="cursor-pointer">No</Text>
      </div>
    </div>
  </div>
);
